import * as React from 'react';
import { ActivePane, useAppStateContext } from '../AppStateProvider/AppStateProvider';
import { Grid, makeStyles, Theme } from '@material-ui/core';
import classnames from 'classnames';
import { Popover } from 'n2p-ui-library';
import { useMemo } from 'react';
import { MenuButton } from '../../icons/MenuButton';
import { getActivePaneInfo } from './Header';

export const useStyles = makeStyles((theme: Theme) => ({
  headerBurgerMenu: {
    width: '60px',
    height: '50px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    marginRight: '0px',
    '&hover': {
      backgroundColor: 'var(--color-primary-light-1)',
    },
  },
  headerContainer: {
    position: 'relative',
    marginLeft: 'auto',
    marginRight: '0px',
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '5px',
  },
  headerBurgerMenuGeneral: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: 'var(--spog-header-height)',
    color: 'var(--color-white)',
  },
  headerProfileMenu: {
    width: '200px',
    listStyle: 'none',
  },

  headerProfileMenuItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '36px',
    padding: '0 0px',
  },
}));

export default function HeaderSmallItemMenu() {
  const classes = useStyles();
  const { dispatch } = useAppStateContext();

  function setActivePane({ pane, paneNumber }: { pane: ActivePane; paneNumber: number }) {
    return paneNumber === 1
      ? () =>
          dispatch({
            type: 'set-active-pane',
            newActivePane: ActivePane.CameraTest,
          })
      : () => dispatch({ type: 'set-active-pane', newActivePane: pane });
  }

  const renderAvatarComponent = useMemo((): JSX.Element => {
    return MenuButton();
  }, []);

  const panesToDisplay = [
    ActivePane.DeviceCheck,
    ActivePane.Connectivity,
    ActivePane.CodecsTest,
    ActivePane.Quality,
    ActivePane.Results,
  ];

  return (
    <div>
      <Grid>
        <div className={classes.headerBurgerMenuGeneral}>
          <div className={classnames(classes.headerContainer, classes.headerBurgerMenu)}>
            <Popover
              trigger="click"
              position="bottom"
              disableScroll
              offset={3}
              contentStyles={{
                animationName: 'fadeInUp',
                animationDuration: '.3s',
                borderRadius: 6,
                marginLeft: '15px',
                marginTop: '-3px',
                height: '195px',
              }}
              arrow={false}
              activatorControlled={renderAvatarComponent}
            >
              <ul className={classes.headerProfileMenu}>
                {panesToDisplay.map((pane) => {
                  const paneInfo = getActivePaneInfo(pane); // Use helper function to get pane details

                  return (
                    <li key={pane} className={classes.headerProfileMenuItem} style={{ paddingTop: '15px' }}>
                      <button
                        type="button"
                        className="n2pc-btn-text"
                        style={{ marginLeft: '10px' }}
                        onClick={() => setActivePane({ pane: paneInfo.pane, paneNumber: paneInfo.paneNumber })}
                      >
                        {paneInfo.label}
                      </button>
                    </li>
                  );
                })}
              </ul>
            </Popover>
          </div>
        </div>
      </Grid>
    </div>
  );
}
